import { render, staticRenderFns } from "./DevFooter.vue?vue&type=template&id=224263f2&"
import script from "./DevFooter.vue?vue&type=script&lang=js&"
export * from "./DevFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports